export default __webpack_public_path__ + "static/media/glyphicons-halflings-regular.be810be3.woff2";